export default __webpack_public_path__ + "static/media/instagramMaps.f9576a89.svg";